<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md"></ion-back-button>
    </ion-buttons>
    <ion-title>Payment</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
   <smr-tips-payments-manager
    (saleUpdated)="onSaleUpdated($event)"
    [sale]="sale">
  </smr-tips-payments-manager>

</ion-content>

<ion-footer class="ion-no-border ion-no-margin">
  <ion-toolbar class="ion-no-padding">
    <smr-sale-checkout-buttons 
      (saleUpdated)="onSaleUpdated($event)"
      [sale]="sale"
      [cashTip]="cashTip"
      [isFromBookings]="isFromBookings"
      [isFromRegisterClosure]="isFromRegisterClosure">
    </smr-sale-checkout-buttons>
  </ion-toolbar>
</ion-footer>
